var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h5 font-weight-bold pl-3"},[_vm._v(" "+_vm._s(_vm.inputGroup.title)+" ")]),_c('p',{staticClass:"text-subtitle-2 text--secondary pl-3"},[_c('CalcTextContainer',[_vm._v(" "+_vm._s(_vm.inputGroup.description)+" ")])],1),_c('InputGroup',{attrs:{"inputs":_vm.inputGroup.inputs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }